import React from 'react';
import PropTypes from 'prop-types';

import PDPFabricReviewsUI from './PDPFabricReviewsUI';

const PDPFabricReviews = ({ reviews }) => (
    <PDPFabricReviewsUI reviews={reviews} />
  );
  
  PDPFabricReviews.propTypes = {
    reviews: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  };

export default PDPFabricReviews;
